(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shop-directory"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const dialog = document.getElementById('ShopAllFilterDialog');
    const initialForm = document.querySelector('form.shop-all-filters');
    const messagesNode = document.getElementById('ShopAllFilterMessages');
    if (!dialog || !initialForm || !messagesNode || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const msg = JSON.parse(messagesNode.textContent);
    const section = initialForm.closest('.shopify-section');
    const page = initialForm.parentElement;
    const tools = page.querySelector('.collection-tools');
    if (!section || !tools) return;
    const body = dialog.querySelector('.sf-filter-body');
    const error = dialog.querySelector('.sf-filter-error');
    const results = document.createElement('div');
    results.id = 'ShopAllResults';
    results.className = 'sf-filter-results';
    results.tabIndex = -1;
    const count = document.createElement('h2');
    count.className = 'sf-filter-results__count';
    count.setAttribute('role', 'status');
    count.setAttribute('aria-live', 'polite');
    count.textContent = page.querySelector('.section-head > p')?.textContent || '';
    results.append(count);
    while (initialForm.nextElementSibling) results.append(initialForm.nextElementSibling);
    initialForm.after(results);
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'sf-filter-trigger';
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    trigger.setAttribute('aria-expanded', 'false');
    const icon = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 6h16M7 12h10M10 18h4"/></svg>';
    tools.classList.add('sf-filter-tools');
    tools.prepend(trigger);
    let form;
    let busy = false;
    let request;
    let previousScroll = 0;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const selectedCount = () => [...form.elements].filter(el => el.type === 'checkbox' && el.checked || el.type === 'number' && el.value !== '').length;
    const updateTrigger = () => { const n = selectedCount(); trigger.innerHTML = icon; trigger.append(document.createTextNode(msg.open + (n ? ' (' + n + ')' : ''))); };
    const enhanceForm = next => {
      form = next;
      body.replaceChildren(form);
      const submit = form.querySelector('[type="submit"]');
      const actions = document.createElement('div');
      actions.className = 'sf-filter-actions';
      const reset = document.createElement('button');
      reset.type = 'button';
      reset.className = 'sf-filter-reset';
      reset.textContent = msg.clear;
      reset.addEventListener('click', () => {
        form.querySelectorAll('input[type="checkbox"]').forEach(el => { el.checked = false; });
        form.querySelectorAll('input[type="number"]').forEach(el => { el.value = ''; });
        form.querySelectorAll('input[name="stock"]').forEach(el => { el.value = ''; });
        error.hidden = true;
        updateTrigger();
      });
      submit.textContent = msg.apply;
      actions.append(reset, submit);
      form.append(actions);
      form.addEventListener('change', updateTrigger);
      form.querySelectorAll('.storecore-filter-pilot__values').forEach(list => {
        if (list.querySelectorAll('input[type="checkbox"]').length < 7) return;
        const heading = list.closest('.storecore-filter-pilot__group').querySelector('h3');
        list.tabIndex = 0;
        list.setAttribute('aria-label', heading.textContent + '. ' + msg.scroll);
        const up = document.createElement('button');
        const down = document.createElement('button');
        [up, down].forEach(button => { button.type = 'button'; button.className = 'sf-filter-scroll'; });
        up.classList.add('sf-filter-scroll--up');
        down.classList.add('sf-filter-scroll--down');
        list.before(up);
        list.after(down);
        const refresh = () => {
          const atTop = list.scrollTop < 2;
          const atEnd = list.scrollHeight - list.clientHeight - list.scrollTop < 3;
          up.disabled = atTop;
          down.disabled = atEnd;
          up.textContent = atTop ? msg.top : '↑ ' + msg.above;
          down.textContent = atEnd ? msg.end : '↓ ' + msg.below;
        };
        up.addEventListener('click', () => list.scrollBy({ top: -list.clientHeight * .75, behavior: reducedMotion.matches ? 'instant' : 'smooth' }));
        down.addEventListener('click', () => list.scrollBy({ top: list.clientHeight * .75, behavior: reducedMotion.matches ? 'instant' : 'smooth' }));
        list.addEventListener('scroll', refresh, { passive: true });
        new ResizeObserver(refresh).observe(list);
      });
      updateTrigger();
    };
    enhanceForm(initialForm);
    trigger.addEventListener('click', () => {
      previousScroll = window.scrollY;
      error.hidden = true;
      dialog.showModal();
      document.body.classList.add('sf-filter-open');
      trigger.setAttribute('aria-expanded', 'true');
    });
    const close = () => dialog.close();
    dialog.querySelector('.sf-filter-close').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('sf-filter-open');
      trigger.setAttribute('aria-expanded', 'false');
      window.scrollTo({ top: previousScroll, behavior: 'instant' });
    });
    const filterUrl = () => {
      const url = new URL(window.location.href);
      for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') || key === 'page' || key === 'stock') url.searchParams.delete(key);
      for (const [key, value] of new FormData(form)) if (String(value).trim() !== '') url.searchParams.append(key, value);
      const sort = tools.querySelector('[name="sort_by"]');
      if (sort) url.searchParams.set('sort_by', sort.value);
      url.hash = 'ShopAllResults';
      return url;
    };
    const render = async (url, push = true) => {
      if (request) request.abort();
      request = new AbortController();
      busy = true;
      results.setAttribute('aria-busy', 'true');
      error.hidden = true;
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = true;
      submit.textContent = msg.loading;
      try {
        const fetchUrl = new URL(url);
        fetchUrl.hash = '';
        fetchUrl.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
        const response = await fetch(fetchUrl, { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Filter response failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextForm = doc.querySelector('form.shop-all-filters');
        if (!nextForm) throw new Error('Filter markup unavailable');
        const nextPage = nextForm.parentElement;
        const nextNodes = [];
        let node = nextForm.nextElementSibling;
        while (node) { const after = node.nextElementSibling; nextNodes.push(node); node = after; }
        const nextCount = nextPage.querySelector('.section-head > p')?.textContent || '';
        count.textContent = nextCount;
        const currentCount = page.querySelector('.section-head > p');
        if (currentCount) currentCount.textContent = nextCount;
        results.replaceChildren(count, ...nextNodes);
        const nextSort = nextPage.querySelector('.collection-sort');
        const currentSort = tools.querySelector('.collection-sort');
        if (nextSort && currentSort) currentSort.replaceWith(nextSort);
        enhanceForm(nextForm);
        if (push) history.pushState({ ...history.state, shopAllFilters: true }, '', url.pathname + url.search + '#ShopAllResults');
        if (dialog.open) dialog.close();
        results.removeAttribute('aria-busy');
        requestAnimationFrame(() => { results.focus({ preventScroll: true }); results.scrollIntoView({ block: 'start', behavior: 'instant' }); });
      } catch (failure) {
        if (failure.name !== 'AbortError') {
          error.textContent = msg.error;
          error.hidden = false;
          if (!dialog.open) { previousScroll = window.scrollY; dialog.showModal(); document.body.classList.add('sf-filter-open'); trigger.setAttribute('aria-expanded', 'true'); }
        }
      } finally {
        busy = false;
        results.removeAttribute('aria-busy');
        form.querySelector('[type="submit"]').disabled = false;
        form.querySelector('[type="submit"]').textContent = msg.apply;
      }
    };
    document.addEventListener('submit', event => {
      if (event.target !== form && !tools.contains(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      const min = form.querySelector('[name="filter.v.price.gte"]');
      const max = form.querySelector('[name="filter.v.price.lte"]');
      if (min?.value && max?.value && Number(min.value) > Number(max.value)) { error.textContent = msg.invalid; error.hidden = false; return; }
      render(filterUrl());
    }, true);
    document.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      if (!results.querySelector('.pagination')?.contains(link) && !form.querySelector('.storecore-filter-pilot__head')?.contains(link)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = new URL(link.href);
      url.hash = 'ShopAllResults';
      render(url);
    }, true);
    window.addEventListener('popstate', () => render(new URL(window.location.href), false));
    if (window.location.hash === '#ShopAllResults') requestAnimationFrame(() => results.scrollIntoView({ block: 'start' }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
  } catch(e) { console.error(e); }
})();

})();
